<div *ngIf="this.isLoading" class="se-loader"></div>
<div class="mb-3 grid-div settings-section">
  <div class="se-inline-form mb-4 hide-in-mobile">
    <div class="col-12 mt-3">
      <select aria-label="resData" class="se-form-control col-2 ml-0" [(ngModel)]="resValue">
        <option *ngFor="let item of resData; let i = index" [ngValue]="item.key">{{item.value}}</option>
      </select>
    </div>

  </div>
  <div class="se-inline-form hide-in-large">
    <div class="nav-container">
      <div class="pill-tabs">
        <input type="radio" id="radio-1" name="pill-tabs" checked (click)="onSettingTabChange(1)" [value]='1' [(ngModel)]="resValue"
               (keypress)="onSettingTabChange(1)"
               (keydown)="onSettingTabChange(1)"
               (keyup)="onSettingTabChange(1)" />
        <label class="pill-tab" for="radio-1">{{labels.parameter| translate}}</label>
        <input type="radio" id="radio-2" name="pill-tabs" checked (click)="onSettingTabChange(2)" (keypress)="onSettingTabChange(2)"
               (keydown)="onSettingTabChange(2)"
               (keyup)="onSettingTabChange(2)"
               [value]='2' [(ngModel)]="resValue" />
        <label class="pill-tab" for="radio-2">{{labels.resources| translate}}</label>
        <input type="radio" id="radio-3" name="pill-tabs" checked (click)="onSettingTabChange(3)" [value]='3' [(ngModel)]="resValue"
               (keypress)="onSettingTabChange(3)"
               (keydown)="onSettingTabChange(3)"
               (keyup)="onSettingTabChange(3)" />
        <label class="pill-tab" for="radio-3">{{labels.commands| translate}}</label>
        <span class="glider"></span>
      </div>
    </div>
    <div class="top-div">
      <div class="filter-sec">
        <input #filtr type="text" aria-label="search" [(ngModel)]="targetSearch"
               class="input-globalsearch" size="50" placeholder={{labels.search|translate}}>
        <a class="SearchLink">
          <em class="fa fa-search SearchIcon"></em>
        </a>
      </div>
    </div>
  </div>

  <div class="col hide-in-mobile">
    <div class="row p-1 btm-m-80" *ngIf="resValue == 0 || resValue == 1">
      <div class="card h-100">
        <div class="card-header p-1">
          <span class="ml-1 h6">{{labels.parameter| translate}}</span>
          <div class="filter-sec-trspnt">
            <button class="btn-filter btn-transparent" (click)='ToggleFilter(dtParam,"param")'>
              <img src="assets/filter.svg" class="icon-filter" alt="filter" height="28" width="24"/> {{ labels.filter | translate }}
            </button>
          </div>
        </div>
        <div class="card-body h-100">
          <p-table #dtParam *ngIf="paramGridData" [columns]="paramertersGridCols" class="tbl-param"
                   [value]="paramGridData" [paginator]="isParamPagination" [rows]="10">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display,'width':col.width}">
                  {{col.header | translate}}
                </th>
                <th scope="col" class="width18Per">{{labels.operations | translate}}</th>
              </tr>
              <tr class="tHead-filter" *ngIf="showParamfilter">
                <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display }">
                  <input aria-label="search" pInputText type="text" *ngIf="col.field == 'label' || col.field =='description'"
                         class="txtSettingFilter" (input)="dtParam.filter($event.target.value, col.field, 'contains')" />
                </th>
                <th scope="col"></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
              <tr>

                <td *ngFor="let col of columns" [ngStyle]="{'display': col.display }" class="p-0">
                  <span *ngIf="col.field==='favourite'">
                    <img src="assets/star-fav.svg" class="icon-action favIcon" (click)="removeFavourite(rowData['id'],rowData['label'])" *ngIf="rowData[col.field]==true"
                         (keypress)="removeFavourite(rowData['id'],rowData['label'])"
                         (keydown)="removeFavourite(rowData['id'],rowData['label'])"
                         (keyup)="removeFavourite(rowData['id'],rowData['label'])" alt="stat-fav" height="29" width="29"/>
                    <img src="assets/star.svg" class="icon-action favIcon" (click)="addFavourite(rowData['id'],rowData['label'])" *ngIf="rowData[col.field]==false"
                         (keypress)="addFavourite(rowData['id'],rowData['label'])"
                         (keydown)="addFavourite(rowData['id'],rowData['label'])"
                         (keyup)="addFavourite(rowData['id'],rowData['label'])" alt="star" height="29" width="29"/>
                  </span>
                  <span *ngIf="col.field !== 'current' && col.field != 'favourite'" class="non-editable pl-2 display-block">
                    {{ rowData[col.field] }}
                  </span>
                  <span [pEditableColumn]="rowData[col.feild]" pEditableColumn="current" *ngIf="col.field === 'current' && col.field != 'favourite'" class="editable pl-2 display-block">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input aria-label="dataFeild" required [id]="'param-current-'+rowData['id']" pInputText type="text" [(ngModel)]="rowData[col.field]" [(min)]="rowData['min']" [(max)]="rowData['max']" (ngModelChange)="validateValue(rowData['current'],rowData['id'],rowData['unit'],rowData['min'],rowData['max'])">

                      </ng-template>
                      <ng-template pTemplate="output">
                        {{ rowData[col.field] }}
                      </ng-template>
                    </p-cellEditor>
                  </span>
                  <span [id]="'param-error-'+rowData['id']" *ngIf="col.field === 'current'" ></span>
                </td>
                <td>
                  <span [id]="'param-'+rowData['id']" class="fa fa-book mr-3 h5 pt-2" (click)="ReadOperation($event,'param',rowData['id'])"
                        (keypress)="ReadOperation($event,'param',rowData['id'])"
                        (keydown)="ReadOperation($event,'param',rowData['id'])"
                        (keyup)="ReadOperation($event,'param',rowData['id'])"></span>
                  <span [id]="'param-w-'+rowData['id']" class="fa fa-pencil-alt h5 "
                        (click)="WriteOperation($event, 'param', rowData['current'],rowData['id'],rowData['unit'],rowData['min'],rowData['max'])"
                        (keypress)="WriteOperation($event, 'param', rowData['current'],rowData['id'],rowData['unit'],rowData['min'],rowData['max'])"
                        (keydown)="WriteOperation($event, 'param', rowData['current'],rowData['id'],rowData['unit'],rowData['min'],rowData['max'])"
                        (keyup)="WriteOperation($event, 'param', rowData['current'],rowData['id'],rowData['unit'],rowData['min'],rowData['max'])"></span>
                </td>

              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
              <tr *ngIf="noParamData">
                <td [attr.colspan]="columns.length - 1">
                  {{labels.noRecords | translate}}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
    <div class="row p-1 btm-m-80" *ngIf="resValue == 0 || resValue == 2">
      <div class="card h-100">
        <div class="card-header p-1">
          <span class="ml-1 h6">{{labels.resources| translate}}</span>
          <div class="filter-sec-trspnt">
            <button class="btn-filter btn-transparent" (click)='ToggleFilter(dtRes,"res")'>
              <img src="assets/filter.svg" class="icon-filter" alt="filter" height="29" width="29"/>  {{ labels.filter | translate }}
            </button>
          </div>
        </div>
        <div class="card-body h-100">

          <p-table #dtRes *ngIf="resGridData" [paginator]="isResPagination" [rows]="10" [columns]="resourcesGridCols" class="tbl-resources" [value]="resGridData">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th scope="col" *ngFor="let col of columns" [ngStyle]="{'width': col.width, 'display': col.display}">
                  {{col.header | translate}}
                </th>
                <th scope="col" class="width18Per">{{labels.operations | translate}}</th>
              </tr>
              <tr class="tHead-filter" *ngIf="showResfilter">
                <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display }">
                  <input aria-label="search" pInputText type="text" *ngIf="col.field == 'label' || col.field =='description'"
                         class="txtSettingFilter" (input)="dtRes.filter($event.target.value, col.field, 'contains')" />
                </th>
                <th scope="col"></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
              <tr>
                <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                  <span *ngIf="col.field=='favourite'">
                    <img src="assets/star-fav.svg" class="icon-action favIcon" (click)="removeFavourite(rowData['id'],rowData['label'])" *ngIf=" rowData[col.field]==true"
                         (keypress)="removeFavourite(rowData['id'],rowData['label'])"
                         (keydown)="removeFavourite(rowData['id'],rowData['label'])"
                         (keyup)="removeFavourite(rowData['id'],rowData['label'])" alt="star-fav" width="29" height="29"/>

                    <img src="assets/star.svg" class="icon-action favIcon" (click)="addFavourite(rowData['id'],rowData['label'])" (keypress)="addFavourite(rowData['id'],rowData['label'])"
                         (keydown)="addFavourite(rowData['id'],rowData['label'])"
                         (keyup)="addFavourite(rowData['id'],rowData['label'])" *ngIf=" rowData[col.field]==false" alt="star-fav" width="29" height="29"/>
                  </span>
                  <span *ngIf="col.field!='favourite'">{{ rowData[col.field] }}</span>
                </td>
                <td>
                  <span [id]="'res-'+rowData['id']" class="fa fa-book mr-3 h5 pt-2" (click)="ReadOperation($event, 'res',rowData['id'])"
                        (keypress)="ReadOperation($event,'res',rowData['id'])"
                        (keydown)="ReadOperation($event,'res',rowData['id'])"
                        (keyup)="ReadOperation($event,'res',rowData['id'])"></span>
                </td>

              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
              <tr *ngIf="noResourcesData">
                <td [attr.colspan]="columns.length - 1">
                  {{labels.noRecords | translate}}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
    <div class="row p-1" *ngIf="resValue == 0 || resValue == 3">
      <div class="card h-100">
        <div class="card-header p-1">
          <span class="ml-1 h6">{{labels.commands| translate}}</span>
          <div class="filter-sec-trspnt">
            <button class="btn-filter btn-transparent" (click)='ToggleFilter(dtCom,"cmd")'>
              <img src="assets/filter.svg" class="icon-filter" alt="filter" height="29" width="29"/>  {{ labels.filter | translate }}
            </button>
          </div>
        </div>
        <div class="card-body h-100">

          <p-table #dtCom [paginator]="isCmdPagination" [rows]="10" *ngIf="commandGridData" [columns]="commandsGridCols" class="tbl-commd" [value]="commandGridData">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th scope="col" *ngFor="let col of columns" [ngStyle]="{'width': col.width, 'display': col.display}">
                  {{col.header | translate}}
                </th>
                <th scope="col" class="width18Per">{{labels.operations | translate}}</th>
              </tr>
              <tr class="tHead-filter" *ngIf="showCmdfilter">
                <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display }">
                  <input aria-label="search" pInputText type="text" *ngIf="col.field == 'label' || col.field =='description'"
                         class="txtSettingFilter" (input)="dtCom.filter($event.target.value, col.field, 'contains')" />
                </th>
                <th scope="col"></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
              <tr>
                <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                  <span *ngIf="col.field=='favourite'">
                    <img src="assets/star-fav.svg" class="icon-action favIcon" (click)="removeFavourite(rowData['id'],rowData['label'])" *ngIf=" rowData[col.field]==true"
                         (keypress)="removeFavourite(rowData['id'],rowData['label'])"
                         (keydown)="removeFavourite(rowData['id'],rowData['label'])"
                         (keyup)="removeFavourite(rowData['id'],rowData['label'])" alt="star-fav" width="29" height="29"/>

                    <img src="assets/star.svg" class="icon-action favIcon" (click)="addFavourite(rowData['id'],rowData['label'])" (keypress)="addFavourite(rowData['id'],rowData['label'])"
                         (keydown)="addFavourite(rowData['id'],rowData['label'])"
                         (keyup)="addFavourite(rowData['id'],rowData['label'])" *ngIf=" rowData[col.field]==false" alt="star" width="29" height="29"/>

                  </span>
                  <span *ngIf="col.field!='favourite'">{{ rowData[col.field] }}</span>
                </td>
                <td>
                  <span [id]="'comm-w-'+rowData['id']" class="fa fa-play mr-3 h5 pt-2" (click)="WriteOperation($event,'comm',null,rowData['id'])"
                        (keypress)="WriteOperation($event,'comm',null,rowData['id'])"
                        (keydown)="WriteOperation($event,'comm',null,rowData['id'])"
                        (keyup)="WriteOperation($event,'comm',null,rowData['id'])"></span>
                </td>

              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
              <tr *ngIf="noCommandsData">
                <td [attr.colspan]="columns.length - 1">
                  {{labels.noRecords | translate}}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>

  </div>
  <div class="col hide-in-large mobile-setting-list">
    <div *ngIf="resValue == 1">
      <div class="row ">
        <div [ngClass]="{'setting-card-mobile support-card':true,'active-div' : (selectedDivId === i)}"
             *ngFor="let paramData of paramGridData | filterBy: targetSearch;let i=index">
          <div *ngFor="let col of paramertersGridCols">
            <div class="col data-row" *ngIf="col.field =='label' || col.field=='description'">
              <div class="col card-col-setting" *ngIf="col.display!='none'">
                <span class="mobile-grid-header">{{col.header|translate}}</span>
                <span class="float-right" *ngIf="col.field=='label'">
                  <img src="assets/star-fav.svg" class="icon-action favIcon" (click)="removeFavourite(paramData['id'],paramData['label'])" *ngIf="paramData['favourite']==true"
                       (keypress)="removeFavourite(rowData['id'],rowData['label'])"
                       (keydown)="removeFavourite(rowData['id'],rowData['label'])"
                       (keyup)="removeFavourite(rowData['id'],rowData['label'])" alt="star-fav" height="29" width="29"/>

                  <img src="assets/star.svg" class="icon-action favIcon" (click)="addFavourite(paramData['id'],paramData['label'])" (keypress)="addFavourite(rowData['id'],rowData['label'])"
                       (keydown)="addFavourite(rowData['id'],rowData['label'])"
                       (keyup)="addFavourite(rowData['id'],rowData['label'])" *ngIf="paramData['favourite']==false" alt="star" height="29" width="29"/>

                </span><br />
                <span class="float-right lblbProcss" *ngIf="col.field=='label'">
                  <label [id]="'labelRead-'+paramData['id']"></label>
                  <label [id]="'labelWrite-'+paramData['id']"></label>
                </span>
                <span class="mobile-grid-data mobile-grid-setting-data-width">
                  {{paramData[col.field]}}
                </span>
              </div>
              <div class="col card-col-setting action-div " *ngIf="col.field=='description'">
                <div class="col cmd-action">
                  <button class="mobile-grid-data float-right se-button button-primary" [id]="'param-'+paramData['id']"
                          (click)="ReadOperation($event, 'param',paramData['id']);toggleParamDiv(i);">
                    {{labels.viewValue | translate }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div id="paramDiv{{i}}" class="col data-row param-info-content">
            <div *ngFor="let col of paramertersGridCols">
              <div class="row data-row" *ngIf="col.field =='min' || col.field=='max' || col.field =='current'|| col.field =='unit'">
                <div class="col" *ngIf="col.display!='none'">
                  <p class="mobile-grid-header" *ngIf="col.field !='current'">{{col.header|translate}}</p>
                  <p class="mobile-grid-data setting-value-width" *ngIf="col.field !='current' ">
                    {{paramData[col.field] || '&nbsp;'}}
                  </p>
                  <p class="mobile-grid-header" *ngIf="col.field =='current'">{{col.header|translate}}</p>
                  <p class="mobile-grid-data setting-value-width" *ngIf="col.field =='current'">
                    <input aria-label="dataFeild" class="current-input" pInputText type="text" [(ngModel)]="paramData[col.field]">
                  </p>
                </div>
              </div>
            </div>
            <div class="col card-col-setting action-div ">
              <div class="col cmd-action">
                <button class="mobile-grid-data float-right  se-button button-primary" [id]="'param-w-'+paramData['id']"
                        (click)="WriteOperation($event,'param', paramData['current'],paramData['id'],paramData['unit'])">
                  {{labels.setValue | translate}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="resValue == 2">
      <div class="row ">
        <div [ngClass]="{'setting-card-mobile support-card':true,'active-div' : (selectedDivId === i)}" *ngFor="let resData of resGridData | filterBy: targetSearch;let i=index">
          <div *ngFor="let col of resourcesGridCols">
            <div class="col data-row" *ngIf="col.field =='label' || col.field=='description'">
              <div class="col card-col-setting" *ngIf="col.display!='none'">
                <span class="mobile-grid-header">{{col.header|translate}}</span>
                <span class="float-right" *ngIf="col.field=='label'">
                  <img src="assets/star-fav.svg" class="icon-action favIcon" (click)="removeFavourite(resData['id'],resData['label'])" (keypress)="removeFavourite(rowData['id'],rowData['label'])"
                       (keydown)="removeFavourite(rowData['id'],rowData['label'])"
                       (keyup)="removeFavourite(rowData['id'],rowData['label'])" *ngIf="resData['favourite']==true" alt="star-fav" height="29" width="29"/>

                  <img src="assets/star.svg" class="icon-action favIcon" (click)="addFavourite(resData['id'],resData['label'])" (keypress)="addFavourite(rowData['id'],rowData['label'])"
                       (keydown)="addFavourite(rowData['id'],rowData['label'])"
                       (keyup)="addFavourite(rowData['id'],rowData['label'])" *ngIf="resData['favourite']==false" alt="star" height="29" width="29"/>

                </span><br />
                <span class="float-right lblbProcss" *ngIf="col.field=='label'">
                  <label [id]="'labelRead-'+resData['id']"></label>
                </span>
                <span class="mobile-grid-data mobile-grid-setting-data-width">
                  {{resData[col.field] || '&nbsp;'}}
                </span>
              </div>
              <div class="col card-col-setting action-div" *ngIf="col.field=='description'">
                <div class="col cmd-action">
                  <button class="mobile-grid-data mobile-grid-setting-data-width float-right se-button button-primary" [id]="'res-'+resData['id']"
                          (click)="toggleResourceDiv(i);ReadOperation($event, 'res',resData['id'])">
                    {{labels.viewValue | translate}}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div id="resDiv{{i}}" class="col data-row param-info-content">
            <div *ngFor="let col of resourcesGridCols">
              <div class="row  data-row" *ngIf="col.field =='current'|| col.field =='unit'">
                <div class="col" *ngIf="col.display!='none'">
                  <p class="mobile-grid-header">{{col.header|translate}}</p>
                  <p class="mobile-grid-data setting-value-width">
                    {{resData[col.field] || '&nbsp;'}}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf=" resValue == 3">
      <div class="row ">
        <div class="card-mobile support-card" *ngFor="let cmdData of commandGridData | filterBy: targetSearch;let i=index">
          <div *ngFor="let col of commandsGridCols">
            <div class="col data-row">
              <div class="col card-col-setting" *ngIf="col.display!='none' && col.field!='favourite'">
                <span class="mobile-grid-header" *ngIf="col.field !=='isActive'">{{col.header|translate}}</span>
                <span class="float-right" *ngIf="col.field=='label' ">
                  <img src="assets/star-fav.svg" class="icon-action favIcon" (click)="removeFavourite(cmdData['id'],cmdData['label'])" (keypress)="removeFavourite(rowData['id'],rowData['label'])"
                       (keydown)="removeFavourite(rowData['id'],rowData['label'])"
                       (keyup)="removeFavourite(rowData['id'],rowData['label'])" *ngIf="cmdData['favourite']==true" alt="star-fav" height="29" width="29"/>

                  <img src="assets/star.svg" class="icon-action favIcon" (click)="addFavourite(cmdData['id'],cmdData['label'])" (keypress)="addFavourite(rowData['id'],rowData['label'])"
                       (keydown)="addFavourite(rowData['id'],rowData['label'])"
                       (keyup)="addFavourite(rowData['id'],rowData['label'])" *ngIf="cmdData['favourite']==false" alt="star" height="29" width="29"/>

                </span><br />
                <span class="float-right lblbProcss" *ngIf="col.field=='label'">
                  <label [id]="'labelWrite-'+cmdData['id']"></label>
                </span>
                <span class="mobile-grid-data mobile-grid-setting-data-width">
                  {{cmdData[col.field] || '&nbsp;'}}
                </span>
              </div>
            </div>
          </div>
          <div class="col card-col-setting action-div ">
            <div class="col cmd-action">
              <button class="mobile-cmd-data mobile-grid-data  se-button button-primary float-right" [id]="'comm-w-'+cmdData['id']"
                      (click)="WriteOperation($event, 'comm',null,cmdData['id'])">

                {{labels.setValue|translate}}
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<p-toast class="mt10" position="top-center" key="warn"></p-toast>
<p-toast class="mt10" position="top-center" key="error"></p-toast>
<p-toast class="mt10" position="top-center" key="success"></p-toast>
